import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import AuthenticatedApp from './components/Auth/AuthenticatedApp';
import AccountlessDonorApp from './pages/VoiceInvitation/DonorShell';
import DonorManagement from './pages/DonorManagement/DonorManagement';
import './App.css';
import { features } from './config/features';

// Screenshot-review fixture for the redesign primitives. The route only exists
// when REACT_APP_DESIGN_SHEET=true; it is never a customer surface.
const DesignSheet = lazy(() => import('./dev/DesignSheet'));

/**
 * Staging identification. Surfaces built on the customer shell carry the
 * note inside their single header; only child story time, which has no
 * shell, keeps the fixed bar so the environment is never unidentified.
 */
const StagingFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const fixedBar = features.stagingMode && pathname === '/story-time';
  return (
    <div className={fixedBar ? 'staging-mode' : undefined}>
      {fixedBar && <div className="staging-banner" role="note">Luma staging · Test accounts only</div>}
      {children}
    </div>
  );
};

function App() {
  const designSheetEnabled = process.env.REACT_APP_DESIGN_SHEET === 'true';
  return (
    <Router>
    <StagingFrame>
      <Routes>
        <Route path="/voice-invitation/manage" element={<DonorManagement />} />
        <Route path="/donor-management/*" element={<DonorManagement />} />
        <Route path="/voice-invitation/*" element={<AccountlessDonorApp />} />
        {designSheetEnabled && (
          <Route
            path="/design-sheet/*"
            element={(
              <Suspense fallback={null}>
                <DesignSheet />
              </Suspense>
            )}
          />
        )}
        <Route
          path="*"
          element={(
            <AppProvider>
              <AuthenticatedApp />
            </AppProvider>
          )}
        />
      </Routes>
    </StagingFrame>
    </Router>
  );
}

export default App;
